<template>
  <div class="realize_wrap">
    <!-- 页头 Banner -->
    <div class="realize_img">
      <div class="img_tit">致力于智能化发展</div>
    </div>
    <!-- Tab 导航：公司介绍 / 联系我们 -->
    <div class="realize_nav_wrap">
      <el-row
        class="realize_nav"
        justify="center"
        type="flex"
      >
        <el-col
          v-for="(tab, index) in tabList"
          :key="index"
          :class="tabSelectIndex === index ? 'active' : ''"
          :span="2"
          :xs="6"
          class="realize_item"
          @click.native="changeTabIndex(index)"
        >
          <div class="nav_top">{{ tab.tit }}</div>
          <div
            :style="tabSelectIndex === index ? '' : 'background:#fff'"
            class="nav_bottom"
          ></div>
        </el-col>
      </el-row>
    </div>
    <!-- Tab 0：公司介绍 -->
    <div
      v-if="tabSelectIndex === 0"
      class="show_box_index"
    >
      <div class="product_shows_wrap">
        <div class="production_title_wrap">
          <div class="production_inner">
            <div class="inner_left">
              <img
                alt=""
                src="../../assets/img/tupianright.png"
              />
            </div>
            <div class="inner_center">
              <div class="production_title">公司介绍</div>
            </div>
            <div class="inner_right">
              <img
                alt=""
                src="../../assets/img/tupianleft.png"
              />
            </div>
          </div>
        </div>
        <!-- 桌面端：公司介绍 -->
        <div class="table_wrap hidden-xs-only">
          <el-form
            class="table_form"
            label-position="left"
            label-width="90px"
          >
            <el-form-item
              v-for="item in companyIntroList"
              :key="item.label"
              class="table_form_item"
              :label="item.label"
            >
              {{ item.content }}
            </el-form-item>
          </el-form>
        </div>
        <!-- 移动端：与桌面端共用同一套文案数据 -->
        <div class="table_wrap_mobile hidden-sm-and-up">
          <div class="table_form">
            <div
              v-for="item in companyIntroList"
              :key="item.label"
              class="table_form_item"
            >
              <span>{{ item.label.replace('：', '') }}:</span>{{ item.content }}
            </div>
          </div>
        </div>
      </div>
      <!-- 我们的资质 -->
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_left">
            <img
              alt=""
              src="../../assets/img/tupianright.png"
            />
          </div>
          <div class="inner_center">
            <div class="production_title">我们的资质</div>
          </div>
          <div class="inner_right">
            <img
              alt=""
              src="../../assets/img/tupianleft.png"
            />
          </div>
        </div>
      </div>
      <div class="advantage_out_wrap">
        <el-row class="advantage_wrap">
          <el-col
            v-for="(item, index) in qualifications"
            :key="index"
            :span="7"
            :xs="11"
            class="qualifications_item"
          >
            <el-image
              v-if="item.img"
              class="qualification_img"
              :src="item.img"
              :alt="item.name"
              :preview-src-list="qualificationPreviewList"
              fit="contain"
            />
            <div class="qualification_caption">
              <p class="qualification_name">{{ item.name }}</p>
              <p class="qualification_org">{{ item.org }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_left">
            <img
              alt=""
              src="../../assets/img/tupianright.png"
            />
          </div>
          <div class="inner_center">
            <div class="production_title">我们的优势</div>
          </div>
          <div class="inner_right">
            <img
              alt=""
              src="../../assets/img/tupianleft.png"
            />
          </div>
        </div>
      </div>
      <div class="advantage_out_wrap">
        <el-row class="advantage_wrap">
          <el-col
            v-for="(item, index) in advantageList"
            :key="index"
            :span="7"
            :xs="11"
            class="advantage_item"
          >
            <div class="item_top">
              <div class="icon hidden-xs-only"><i :class="item.icon"></i></div>
              <div class="tit">{{ item.title }}</div>
            </div>
            <ul
              v-for="(desc, index2) in item.desc"
              :key="index2"
              class="item_desc"
            >
              <li>{{ desc }}</li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- Tab 1：联系我们 -->
    <div
      v-if="tabSelectIndex === 1"
      class="show_box_index"
    >
      <div class="four_wrap">
        <el-row
          :gutter="10"
          class="out_card"
          justify="center"
          type="flex"
        >
          <el-col
            v-for="(item, index) in contactMsg"
            :key="index"
            :span="7"
            class="card_item"
          >
            <el-card
              :body-style="{ padding: '0px' }"
              class="card_content"
            >
              <div style="padding: 14px">
                <img
                  :src="item.icon"
                  class="image"
                />
                <div style="margin-top: 20px; font-size: 1rem; font-weight: bold">
                  {{ item.tit }}
                </div>
                <div class="bottom clearfix">
                  <template v-if="Array.isArray(item.desc)">
                    <el-button
                      v-for="(line, lineIndex) in item.desc"
                      :key="lineIndex"
                      class="button contact_line"
                      style="font-size:0.7rem;"
                      type="text"
                    >{{ line }}</el-button>
                  </template>
                  <el-button
                    v-else
                    class="button"
                    style="font-size:0.7rem;"
                    type="text"
                  >{{ item.desc }}</el-button>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="real_wrap">
        <ReailzeCard
          :reailzeList="reailzeList"
          class="hidden-sm-and-up"
        />
      </div>
    </div>
    <CallMe />
    <MobileCallme></MobileCallme>
  </div>
</template>

<script>
import CallMe from '../callme/index'
import MobileCallme from '../callme/MobileCallme.vue'
import ReailzeCard from './ReailzeCard.vue'

// 资质证书：图片编号 + 证书名称 + 发证机构
const QUALIFICATION_LIST = [
  { id: 1, name: '企业信用等级证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 2, name: '企业资信等级证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 3, name: '副会长单位证书', org: '山东省装备制造业协会' },
  { id: 4, name: '中国诚信经理人证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 5, name: '中国诚信企业家证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 6, name: '重合同守信用企业证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 7, name: '质量服务诚信单位证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 8, name: '重质量守信用企业证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 9, name: '重服务守信用企业证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 10, name: '诚信供应商企业证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 11, name: '诚信经营示范单位证书', org: '盛世鼎元（北京）国际信用评价有限公司' },
  { id: 12, name: '质量管理体系认证证书', org: '北京国标联合认证有限公司' },
  { id: 13, name: 'Quality Management System Certificate', org: 'Beijing Guobiao United Certification Co., Ltd.' },
  { id: 14, name: '环境管理体系认证证书', org: '北京国标联合认证有限公司' },
  { id: 15, name: 'Environmental Management System Certificate', org: 'Beijing Guobiao United Certification Co., Ltd.' },
  { id: 16, name: '职业健康安全管理体系认证证书', org: '北京国标联合认证有限公司' },
  { id: 17, name: 'Occupation Health Safety Management System Certificate', org: 'Beijing Guobiao United Certification Co., Ltd.' },
  { id: 18, name: '智能技术应用与产业园区促进发展工作委员会委员单位聘书', org: '山东省自动化学会' },
  { id: 19, name: 'Information Security Management System Certificate', org: '神州亿鑫（北京）认证有限公司' },
  { id: 20, name: '信息安全管理体系认证证书', org: '神州亿鑫（北京）认证有限公司' },
  { id: 21, name: 'Information Technology Service Management System Certificate', org: '神州亿鑫（北京）认证有限公司' },
  { id: 22, name: '信息技术服务管理体系认证证书', org: '神州亿鑫（北京）认证有限公司' },
]

// 路由路径末段 -> Tab 索引（/about/intro 公司介绍，/about/contact 联系我们）
const ROUTE_TAB_MAP = {
  intro: 0,
  contact: 1,
  '1': 0,
  '2': 1,
  '4': 1,
}

export default {
  data () {
    return {
      // 顶部 Tab 导航
      tabList: [
        { tit: '公司介绍' },
        { tit: '联系我们' },
      ],
      tabSelectIndex: 0,
      // 公司介绍文案（桌面端与移动端共用）
      companyIntroList: [
        {
          label: '公司简介：',
          content:
            '山东智能工业装备有限公司成立于2014年，是一家以技术创新为核心驱动力的高科技企业。公司注册资本1000万元，专注于软件与人工智能、新装备研发及新能源领域的探索与应用，为政府与企业客户提供智能化装备与解决方案，助力产业升级与绿色低碳发展。',
        },
        {
          label: '使命：',
          content:
            '以"科技赋能未来"为使命，持续推动产业智能化升级，为客户创造独特而持续的价值。',
        },
        {
          label: '愿景：',
          content:
            '成为软件与AI、新装备、新能源领域的领军企业，以技术创新引领行业发展，为社会创造更多价值。',
        },
        {
          label: '价值观：',
          content:
            '存在的理由是持续为用户创造独特价值；学习和创造是我们的信仰；坚持就是胜利；真诚而专业；成就伙伴，成就自我。',
        },
      ],
      // 资质证书列表（created 中加载图片）
      qualifications: [],
      // 公司核心优势
      advantageList: [
        {
          icon: '',
          title: '团队能力',
          desc: ['技术驱动型队伍', '具备深厚的技术积累和丰富的实践经验'],
        },
        {
          icon: '',
          title: '持续创新',
          desc: ['高研发费用占比', '已获得多项国家专利和软件著作权'],
        },
        {
          icon: '',
          title: '技术领先',
          desc: [
            '掌握多项核心技术',
            '为客户提供高效、可靠的解决方案',
          ],
        },
        {
          icon: '',
          title: '行业经验',
          desc: [
            '多行业项目经验',
            '为客户提供针对性解决方案',
          ],
        },
        {
          icon: '',
          title: '定制化服务',
          desc: ['量身定制解决方案', '确保产品与服务与客户业务高度契合'],
        },
        {
          icon: '',
          title: '快速响应',
          desc: [
            '完善的客户服务体系',
            '7×24小时技术支持确保问题及时解决',
          ],
        },
      ],
      // 联系方式卡片（desc 可为字符串或邮箱数组）
      contactMsg: [
        {
          tit: '商务合作',
          desc: 'zngyzb@zngyzb.com',
          icon: require('../../assets/img/61.png'),
        },
        {
          tit: '售前咨询',
          desc: '0531-82899508',
          icon: require('../../assets/img/60.png'),
        },
        {
          tit: '技术支持',
          desc: ['xinnengyuan@zngyzb.com', 'ruanjian@zngyzb.com'],
          icon: require('../../assets/img/61.png'),
        },
      ],
      // 移动端办公地点（传递给 RealizeCard）
      reailzeList: [
        {
          tit: '济南总部',
          address: '山东省济南市历城区郭店街道虞山路4567号新页智能智造产业园4号楼东座102户',
          phone: '0531-82899508',
        },
      ],
    }
  },
  computed: {
    /** 资质证书预览图列表（支持点击后左右切换） */
    qualificationPreviewList () {
      return this.qualifications.map((item) => item.img).filter(Boolean)
    },
  },
  methods: {
    /** 切换顶部 Tab */
    changeTabIndex (index) {
      this.tabSelectIndex = index
    },
    /** 根据当前路由同步 Tab 选中状态 */
    syncTabFromRoute () {
      const routeSegment = this.$route.path.split('/').pop()
      this.tabSelectIndex = ROUTE_TAB_MAP[routeSegment] ?? 0
    },
    /** 加载资质证书图片，文件不存在时返回 null */
    showQualificationsImg (index) {
      try {
        return require(`../../assets/img/qualifications/grade${index}.png`)
      } catch (error) {
        console.error(error)
        return null
      }
    },
    /** 初始化资质证书图片地址 */
    initQualificationImages () {
      this.qualifications = QUALIFICATION_LIST.map((item) => ({
        ...item,
        img: this.showQualificationsImg(item.id),
      })).filter((item) => item.img)
    },
  },
  components: {
    CallMe,
    MobileCallme,
    ReailzeCard,
  },
  created () {
    this.initQualificationImages()
    this.syncTabFromRoute()
  },
  watch: {
    $route () {
      this.syncTabFromRoute()
    },
  },
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/img/aboutbg.054cc8b.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .realize_nav_wrap {
    width: 100%;
    height: 60px;
    @media screen and (max-width: 768px) {
      height: 50px;
    }

    .realize_nav {
      height: 100%;
      display: flex;
      align-items: center;

      .active {
        font-weight: bold;
        color: #000;
      }

      .realize_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .nav_top {
          font-size: 18px;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }

        .nav_bottom {
          width: 30%;
          height: 4px;
          margin-top: 10px;
          background: #2091d3;
        }
      }
    }
  }

  .product_shows_wrap {
    width: 100%;
    background: url("../../assets/img/intro-bg-company.png") center center no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: -7px;
    box-sizing: border-box;
    height: 700px;
    position: relative;
    @media screen and (max-width: 768px) {
      background: #f4f9fc;
      height: auto;
    }

    .table_wrap {
      position: absolute;
      top: 23%;
      left: 20%;
      width: 600px;

      .table_form {
        .table_form_item {
          font-weight: bold;
        }
      }
    }

    .table_wrap_mobile {
      padding: 1rem;

      p {
        font-size: 0.9rem;
      }

      .table_form {
        .table_form_item {
          font-weight: bold;
          margin-top: 1rem;
          font-size: 0.85rem;

          span {
            color: #000;
            font-size: 0.9rem;
            padding-right: 30px;
          }
        }
      }
    }
  }

  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;

    .advantage_wrap {
      width: 70%;
      display: flex;
      margin-top: 70px;
      justify-content: center;
      flex-wrap: wrap;
      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .advantage_item {
        height: auto;
        padding: 30px 20px 60px 20px;
        margin-right: 10px;

        &:nth-child(1) {
          background: url("../../assets/img/newEdition/31.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }

        &:nth-child(2) {
          background: url("../../assets/img/newEdition/32.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }

        &:nth-child(3) {
          background: url("../../assets/img/newEdition/32.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }

        &:nth-child(4) {
          background: url("../../assets/img/newEdition/33.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }

        &:nth-child(5) {
          background: url("../../assets/img/newEdition/34.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }

        &:nth-child(6) {
          background: url("../../assets/img/newEdition/35.png") 90% 10%
            no-repeat;
          background-size: 20%;
        }

        margin: 15px;
        box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.1);
        @media screen and (max-width: 768px) {
          margin: 0;
          padding: 0 15px;
          margin-top: 3px;
          height: 140px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          height: 200px;
        }

        .item_top {
          display: flex;
          align-items: center;
          @media screen and (max-width: 768px) {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
          }

          .icon {
            i {
              color: #2091d3;
              font-size: 26px;
              padding-right: 10px;
              @media screen and (max-width: 768px) {
                font-size: 2rem;
                margin-bottom: 10px;
              }
            }
          }

          .tit {
            width: 100%;
            color: #1c1c1c;
            font-size: 28px;
            font-weight: bold;
            @media screen and (max-width: 768px) {
              font-size: 1rem;
              text-align: left;
            }
          }
        }

        .item_desc {
          font-size: 20px;
          line-height: 20px;
          margin: 0;
          padding: 0;
          margin-top: 20px;
          color: #646464;
          list-style: none;

          li {
            line-height: 2rem;
            @media screen and (max-width: 768px) {
              line-height: 1rem;
              font-size: 12px;
            }

            &:first-child {
              margin-top: 30px;
            }
          }
        }
      }
      .qualifications_item {
        height: auto;
        padding: 24px 20px 28px;
        margin: 15px;
        box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.1);
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;

        .qualification_img {
          width: 100%;
          display: block;
          cursor: zoom-in;
          border-radius: 2px;
          transition: transform 0.25s ease, box-shadow 0.25s ease;

          ::v-deep .el-image__inner {
            width: 100%;
            height: auto;
            display: block;
          }

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
          }
        }

        .qualification_caption {
          width: 100%;
          margin-top: 14px;
          text-align: center;
        }

        .qualification_name {
          margin: 0;
          font-size: 15px;
          font-weight: 600;
          line-height: 1.45;
          color: #1c1c1c;
        }

        .qualification_org {
          margin: 6px 0 0;
          font-size: 13px;
          line-height: 1.5;
          color: #787878;
        }

        @media screen and (max-width: 768px) {
          margin: 6px;
          padding: 12px 10px 14px;
          height: auto;
          min-height: 0;

          .qualification_img:hover {
            transform: none;
            box-shadow: none;
          }

          .qualification_caption {
            margin-top: 10px;
          }

          .qualification_name {
            font-size: 12px;
          }

          .qualification_org {
            font-size: 11px;
            margin-top: 4px;
          }
        }
      }
    }
  }

  .china_map {
    width: 70%;
    margin: 50px auto;

    img {
      width: 100%;
    }
  }

  .timeline_wrap {
    width: 70%;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }

    .timeline_card {
      h4 {
        font-size: 24px;
        @media screen and (max-width: 768px) {
          font-size: 18px;
        }
      }

      .timeline_time {
        font-size: 12px;
      }

      img {
        width: 30%;
        margin-top: 20px;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
      }
    }
  }

  .three_box {
    width: 70%;
    margin: 0 auto;
    height: 200px;
    text-align: center;
    background: url("../../assets/img/ryzz.bc140e4.jpg") 0 0 no-repeat;
    background-size: cover;
    @media screen and (max-width: 768px) {
      width: 100%;
    }

    h1 {
      font-size: 40px;
      line-height: 200px;
      color: #fff;
    }
  }

  .three_box_card {
    width: 70%;
    margin: 30px auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }

    .out_card {
      flex-wrap: wrap;

      .card_item {
        @media screen and (max-width: 768px) {
          margin-top: 10px;
        }

        &:nth-child(n + 4) {
          margin-top: 10px;
        }

        img {
          padding-top: 30px;
          width: 100%;
        }
      }
    }
  }

  .four_wrap {
    width: 70%;
    margin: 0 auto;
    background: url("../../assets/img/58.e28b1c0.png") 0 0 no-repeat;
    background-size: cover;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 150px;
    }

    .out_card {
      width: 100%;
      flex-wrap: wrap;

      .card_item {
        &:nth-child(n + 4) {
          margin-top: 10px;
        }

        .card_content {
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 100%;

          img {
            padding-top: 30px;
            width: 30%;
            @media screen and (max-width: 768px) {
              width: 50%;
            }
          }

          .contact_line {
            display: block;
            width: 100%;
            margin: 0;
            padding: 2px 0;
            line-height: 1.5;
          }
        }
      }
    }
  }

  .four_card_spa {
    width: 70%;
    margin: 30px auto;

    .out_card {
      .card_item {
        h1 {
          font-size: 30px;
          margin-top: 10px;
        }

        img {
          margin-top: 30px;
          width: 5%;
        }

        p {
          font-size: 12px;
          margin-top: 10px;
        }

        .card_bg {
          width: 30px;
          height: 5px;
          background: #13519f;
        }
      }
    }
  }
}

.production_title_wrap {
  width: 100%;
  margin-top: 50px;
  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }

  .production_inner {
    display: flex;
    justify-content: center;

    .inner_left {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }

      img {
        width: 30%;
      }
    }

    .inner_center {
      width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 50px;
      @media screen and (max-width: 768px) {
        flex: 2.2;
      }

      .production_title {
        font-size: 40px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }

      .production_desc {
        font-size: 16px;
        color: #787878;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }

    .inner_right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }

      img {
        width: 30%;
      }
    }
  }
}
</style>